/** Maps fetch / network failures to employee-friendly copy (no stack traces in UI). */
export function friendlyNetworkMessage(error: unknown, fallback = "Something went wrong. Try again."): string {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return "You're offline. Check your connection, then try again.";
  }
  if (error instanceof DOMException && error.name === "AbortError") {
    return "Request timed out. Check your connection and try again.";
  }
  const msg = error instanceof Error ? error.message : String(error);
  const lower = msg.toLowerCase();
  if (lower.includes("failed to fetch") || lower.includes("networkerror") || lower.includes("load failed")) {
    return "Connection interrupted. Your progress is saved — try again when signal is back.";
  }
  if (lower.includes("timeout") || lower.includes("timed out")) {
    return "This is taking longer than usual. Check your connection and try again.";
  }
  if (msg.trim()) return msg;
  return fallback;
}

export function isRetryableNetworkError(error: unknown): boolean {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  if (error instanceof DOMException && error.name === "AbortError") return true;
  const msg = (error instanceof Error ? error.message : String(error)).toLowerCase();
  return (
    msg.includes("failed to fetch") ||
    msg.includes("networkerror") ||
    msg.includes("load failed") ||
    msg.includes("timeout") ||
    msg.includes("timed out")
  );
}

export function isRetryableHttpStatus(status: number): boolean {
  return status === 408 || status === 429 || status >= 500;
}
